export let thursdayAbbreviatedLowercase = "efIG$c";
export default {thursdayAbbreviatedLowercase};